import { ManageTable, type ManageField } from '@/components/ManageTable'
import { Input } from '@/components/ui/input'

export default function Plat() {
  const fields: ManageField[] = [
    {
      desc: '名称',
      field: 'name',
    },
    {
      desc: 'appid',
      field: 'appid',
      render: (val, row) =>
        row.info ? row.info.live_config.tim_sdkappid : row.appid,
    },
    {
      desc: 'stream',
      field: 'stream',
    },
    {
      desc: '下载链接',
      field: 'host1',
      render: (val, row) => row?.info?.web_url,
    },
    {
      desc: '源地址',
      field: 'meta',
    },
    {
      desc: '代理号',
      field: 'proxy',
    },
    {
      desc: 'token',
      field: 'token',
      NoShowInTable: true,
    },
    {
      desc: '热数据仓',
      field: 'db',
      Comp: <Input type="number" />,
    },
    {
      desc: '更新时间',
      field: 'update_time',
    },
    {
      desc: '备注',
      field: 'desc',
      NoShowInTable: true,
    },
  ]

  return (
    <div className="h-full p-6 overflow-auto">
      <h1 className="text-2xl font-bold mb-6">平台管理</h1>
      <ManageTable fields={fields} collect="plat" />
    </div>
  )
}
